// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__36bK4","dragIcon":"Choice_dragIcon__16vXQ","left":"Choice_left__3GFWD","input":"Choice_input__2wloX"};